export default "__VITE_ASSET__DmthbPAS__"